import api from './axios';
import { Station, StationType } from '../types';

export const stationsApi = {
  getAll: (type?: StationType) =>
    api.get<Station[]>('/stations', { params: type ? { type } : undefined }),

  getById: (id: number) =>
    api.get<Station>(`/stations/${id}`),

  create: (data: Partial<Station>) =>
    api.post<Station>('/stations', data),

  update: (id: number, data: Partial<Station>) =>
    api.put<Station>(`/stations/${id}`, data),

  delete: (id: number) =>
    api.delete(`/stations/${id}`),

  testPrint: (id: number) =>
    api.post<{ ok: boolean; reason?: string }>(`/stations/${id}/test-print`),
};
